import i18n from "../../i18n";
import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";

const GraphQlLoading = ({label, component, variant, color, disableShrink, size, ...props}) => (
    <Typography component={component || 'span'} variant={variant || "body2"} {...props}>
        <CircularProgress
            color={color}
            disableShrink={disableShrink}
            size={size || 14}
            style={{marginRight: 5}}
        />
        {label || (i18n.get('default.please_wait') + '...')}
    </Typography>
);

export default GraphQlLoading;
